import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { Typography, CircularProgress, IconButton } from '@material-ui/core';
import { fullAddress } from 'utilities/address';
import { toCurrency } from 'utilities/format';
import BadgeSection from 'components/underwrite/shared/header/BadgeSection';
import { ContentCard, LabelledOutline } from 'components/layout';
import  ReplayIcon from '@material-ui/icons/Replay';

const PropertyUWLastCompleted = ({ classes, lastCompletedValuation, isFetchingLastCompletedValuation, onActionClick }) => {
  const address = fullAddress(lastCompletedValuation);

  if (isFetchingLastCompletedValuation) {
    return (
      <ContentCard id='propUWLastCompleted' cardWidth='512px' className={classes.contentCard}>
        <div className={classes.noLastValuationWrapper}>
          <CircularProgress size={24} />
        </div>
      </ContentCard>
    )
  }

  return (
    (lastCompletedValuation && address) ? // Check if user has completed an UW before- if not, will be null
    // title='Last Completed UW'
    <LabelledOutline id='propUWLastCompleted2' label="Your Last Underwrite" outlineWidth="512px" marginLeft="8px" classes={{ content: classes.labelledOutlineContent }}>
      <Typography variant="subtitle2">{address}</Typography>
      <BadgeSection selectedOpportunity={lastCompletedValuation} />
      <Typography className={classes.rent}><strong>Input Rent:</strong> {toCurrency(lastCompletedValuation.rent, 0)}</Typography>
      <Typography className={classes.subtitle}><strong>After Repair Value:</strong> {toCurrency(lastCompletedValuation.afterRepairValue, 0)}</Typography>
    </LabelledOutline> :
    lastCompletedValuation == null ? (
    <ContentCard id='propUWLastCompleted' cardWidth='512px' className={classes.contentCard}>
      <div className={classes.noLastValuationWrapper}>
        <Typography className={classes.subtitle}>No previous underwrite found under your name in the last day.</Typography>
      </div>
    </ContentCard>) :
    (lastCompletedValuation && address === null &&
      <ContentCard id='propUWLastCompleted' cardWidth='512px' className={classes.contentCardError}>
        <div className={classes.noLastValuationWrapperError}>
          <Typography className={classes.subtitle}>Failed to fetch the last underwrite.</Typography>
          <IconButton aria-label="replay" title="Retry" className={classes.noLastValuationWrapperErrorIcon} size='small' onClick={onActionClick}>
            <ReplayIcon />
          </IconButton>
        </div>
      </ContentCard>)
  )
}

const styles = theme => ({
  labelledOutlineContent: {
    padding: '12px 16px'
  },
  contentCard: {
    borderRadius: 8,
    border: '2px solid #80a4c7',
    boxShadow: 'none'
  },
  contentCardError: {
    borderRadius: 8,
    border: '2px solid #b72b2b',
    boxShadow: 'none'
  },
  rent: {
    marginTop: 2,
    fontSize: '0.8rem'
  },
  subtitle: {
    fontSize: '0.8rem'
  },
  noLastValuationWrapper: {
    display: 'flex',
    justifyContent: 'center'
  },
  noLastValuationWrapperError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.red.dark,
  },
  noLastValuationWrapperErrorIcon: { 
    display: 'flex',
    justifyContent: 'center', 
    alignItems: 'center',
    color: theme.palette.red.dark,
  }
});
const mapStateToProps = (state) => ({
  lastCompletedValuation: state.propertyUWState.lastCompletedValuation,
  isFetchingLastCompletedValuation: state.propertyUWState.isFetchingLastCompletedValuation
})
const mapDispatchToProps = (dispatch) => ({
})
export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PropertyUWLastCompleted);
